<img
    [src]="image()"
    [class.hidden]="loading()"
    [class.fill]="fill()"
    [class.contain]="!fill()"
    #final
    (load)="loaded()"
    [style]="style()"
>
@if (loading()) {
    <img
        [src]="thumbnail()"
        [class.fill]="fill()"
        [class.contain]="!fill()"
        [style]="style()"
    >
    <span class="loading-text">{{'crews.channels.loading' | translate}}</span>
}
